/**
 * This file is auto-generated from FaqSection.loc.yaml
 * Do not edit this file directly. Edit the source file instead.
 */

import type { Translation } from '@nzyme/i18n-core';

export const faqTitle: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'FAQ';
        case 'pl':
            return 'FAQ';
    }
};

export const faqWhatIsHealedTitle: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'What is Healed?';
        case 'pl':
            return 'Czym jest Healed?';
    }
};

export const faqWhatIsHealedDescription: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Healed is a platform where you can quickly receive medical help online. A doctor reviews your symptoms and prepares a treatment plan. If necessary, they also issue an e-prescription or a sick note.';
        case 'pl':
            return 'To centrum medyczne, w którym możesz otrzymać wsparcie lekarzy specjalistów bez wychodzenia z domu, wpisane do Rejestru Podmiotów Wykonujących Działalność Leczniczą, nr 000000294316.';
    }
};

export const faqHowLongWaitTitle: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'How long will I wait for the consultation?';
        case 'pl':
            return 'Jak długo będę czekać na konsultację?';
    }
};

export const faqHowLongWaitDescription: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'You will receive help the same day (if you start your consultation before noon). Immediately after you describe your symptoms, we will start arranging your consultation with the right doctor. In the evening, at night, or on public holidays, waiting times may be longer.';
        case 'pl':
            return 'Po wysłaniu ankiety lekarz przeanalizuje objawy. Pomoc otrzymasz jeszcze tego samego dnia (pod warunkiem rozpoczęcia konsultacji do południa).';
    }
};

export const faqWillIGetPrescriptionTitle: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Will I definitely get a prescription or sick note?';
        case 'pl':
            return 'Czy mogę otrzymać receptę lub zwolnienie lekarskie?';
    }
};

export const faqWillIGetPrescriptionDescription: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'No. This decision is always made by the doctor.';
        case 'pl':
            return 'Tak. Pamiętaj jednak, że to lekarz decyduje o ich wystawieniu.';
    }
};

export const faqAnyMedicineTitle: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Can I request a prescription for any medicine?';
        case 'pl':
            return 'Czy mogę poprosić o receptę na dowolny lek?';
    }
};

export const faqAnyMedicineDescription: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'The doctor decides whether and what medication to prescribe, based on your health condition and current regulations.';
        case 'pl':
            return 'To lekarz decyduje, czy i jaki lek przepisać, na podstawie Twojego stanu zdrowia i obowiązujących przepisów. Natomiast, jeżeli chcesz tylko odnowić receptę, powiedz to nam w ankiecie.';
    }
};

export const faqEmergencyTitle: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Can I get medical help in an emergency?';
        case 'pl':
            return 'Czy mogę liczyć na pomoc w nagłym przypadku?';
    }
};

export const faqEmergencyDescription: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'No. Healed does not replace emergency services. If your condition is urgent or life-threatening, call 112 or go to the nearest emergency department.';
        case 'pl':
            return 'Healed wspiera Cię na co dzień. Jednak jeśli potrzebujesz natychmiastowej pomocy medycznej, zadzwoń pod 112 lub udaj się na najbliższy Szpitalny Oddział Ratunkowy.';
    }
};

export const faqCostTitle: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'How much does it cost?';
        case 'pl':
            return 'Ile to kosztuje?';
    }
};

export const faqCostDescription: Translation<{ price: unknown }> = (lang, params) => {
    switch (lang) {
        case 'en':
            return [
                'At Healed, a consultation costs ',
                params.price,
                '. We do not charge extra for issuing prescriptions or sick notes.',
            ];
        case 'pl':
            return [
                'Koszt konsultacji to ',
                params.price,
                ' i obejmuje wystawienie ewentualnego zwolnienia lub recepty.',
            ];
    }
};
